import React from 'react'
import WorkingDaysCard from '@/components/Dashboard/WorkingDaysCard'
import EmployeesOnLeaveCard from '@/components/Dashboard/EmployeesOnLeaveCard'
import TodaysBirthdaysCard from '@/components/Dashboard/TodaysBirthdaysCard'
import { PageHeader } from '@/components/shared'

const Dashboard = () => {
  return (
    <div>
      <PageHeader title="Dashboard" />
      
      <div className="grid gap-4 lg:grid-cols-2">
        <WorkingDaysCard />
        <EmployeesOnLeaveCard />
      </div>
      
      <div className="mt-4">
        <TodaysBirthdaysCard />
      </div>
    </div>
  )
}

export default Dashboard
